import {connect} from "react-redux";
import {default as PdfV} from "./PdfViewer";
import {get} from "lodash";
import {actions as pdfActions} from "./logic/pdfActions";
export const PdfViewer = connect(
    (state) => {
        return {
            open: state.pdf.open,
            url: state.pdf.url,
            token: get(state.login.credentials,"id_token", null),
            authenticated: get(state.login,"authenticated", false),
        };
    }, (dispatch) => ({
        onClose: () => dispatch(pdfActions.ON_CLOSE_PDF.call()),
        clean: () => dispatch(pdfActions.CLEAN.call())
    }))(PdfV);